module.exports = __webpack_public_path__ + "img/app_default_img4.729a12e6.png";